export const stopApp = () => {
  console.log('[reload] BaseTour.stopApp');
  window.location.reload();
};
